import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'div-validation-message',
  templateUrl: './div-validation-message.component.html',
  styleUrls: ['./div-validation-message.component.css']
})
export class DivValidationMessageComponent {

  @Input() control: UntypedFormControl | undefined = undefined;
  @Input() labelMessage: string = '';
  @Input() messageRequired: string = 'Información es requerida.';
  @Input() messagePattern: string = '';
  @Input() messageSameValue: string = '';
  @Input() messageCustomFn: string = '';
  @Input() messageGreaterThanZero: string = '';
  @Input() messageDifferenceLimit: string = '';

  constructor() {

  }


}
